import React from 'react';


const ImageReusable = ({ src, alt = 'Image', className = '' }) => {
    const defaultImage = '/images/photoForGoFit.jpg';


    return (
        <img
            src={src || defaultImage}
            alt={alt}
            className={className}
            onError={(e) => {
                e.target.onerror = null;
                e.target.src = defaultImage;
            }}
        />
    );
};

export {ImageReusable};
